/* this file is transformed by vux-loader */
/* eslint-disable */
import _createForOfIteratorHelper from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _slicedToArray from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.slice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Popup from "vux/src/components/popup/index.vue";
import ViewBox from "vux/src/components/view-box/index.vue";
import PopupPicker from "vux/src/components/popup-picker/index.vue";
import Group from "vux/src/components/group/index.vue";
import XInput from "vux/src/components/x-input/index.vue";
import XTextarea from "vux/src/components/x-textarea/index.vue";
import Datetime from "vux/src/components/datetime/index.vue";
import XSwitch from "vux/src/components/x-switch/index.vue";
import Cell from "vux/src/components/cell/index.vue";
import ImgUploadInput from '@/components/ImgUploadInput';
import FileUpload from '@/components/FileUpload';
import ScanCell from '@/components/ScanCell';
import PositionCell from '@/components/PositionCell';
import PopupCheckList from './PopupCheckList';
import SmyXAddress from './SmyXAddress';
import SmyCheckBox from './SmyCheckBox';
import utils from '@/utils/utils';
import SelectPicker from '@/components/Base/SelectPicker';

function flatTree() {
  var tree = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  function format(v) {
    return {
      name: v.value,
      value: String(v.id),
      parent: v.fk_t_parent_id === -1 ? 0 : String(v.fk_t_parent_id)
    };
  }

  try {
    return tree.reduce(function (p, c) {
      p = p.concat(format(c)).concat(flatTree(c.dropList));
      return p;
    }, []);
  } catch (error) {
    console.log('flatTree -> error', error);
    return [];
  }
}

export default {
  name: 'CustomFormList',
  components: {
    SelectPicker: SelectPicker,
    Cell: Cell,
    PopupCheckList: PopupCheckList,
    XInput: XInput,
    XTextarea: XTextarea,
    Group: Group,
    Popup: Popup,
    ViewBox: ViewBox,
    PopupPicker: PopupPicker,
    Datetime: Datetime,
    XSwitch: XSwitch,
    ImgUploadInput: ImgUploadInput,
    FileUpload: FileUpload,
    ScanCell: ScanCell,
    PositionCell: PositionCell,
    SmyCheckBox: SmyCheckBox,
    SmyXAddress: SmyXAddress
  },
  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 表单label标签宽度
    labelWidth: {
      type: Number,
      default: 9.6
    },
    getValueName: {
      type: Boolean,
      default: false
    },
    onlyCamera: {
      type: Boolean,
      default: false
    },
    isPc: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      flatTree: flatTree,
      list: []
    };
  },
  watch: {
    data: {
      handler: function handler(val) {
        var _this = this;

        /* eslint-disable */
        var list = utils.deepCopy(this.data) || [];
        list.forEach(function (v) {
          if (_this.isPc) {
            v.name = v.tfname;
          }

          if ([3, 8].indexOf(v.type) !== -1) {
            v.dropList = v.dropList ? v.dropList.map(function (item) {
              return {
                value: item.id + '',
                name: item.value
              };
            }) : [];
          }

          if ([18].indexOf(v.type) !== -1) {
            _this.$set(v, '_isShow', false);

            _this.$set(v, '_name', 'false');

            _this.$set(v, 'arrvalue', v.ovalue ? v.ovalue.split(',').map(Number) : []);
          }

          if (!v.ovalue) {
            // 空数据格式化
            if (v.type === 3) {
              v.ovalue = '';
            } else if ([7, 16].indexOf(v.type) !== -1) {
              v.ovalue = 0;
            } else {
              v.ovalue = [];
            }
          } else {
            // 数据回显
            if ([3, 7, 16].indexOf(v.type) === -1) {
              // 多选数据过滤
              if (v.type === 8) {
                var value = v.ovalue.split(',');
                v.ovalue = value.filter(function (item) {
                  return v.dropList.map(function (v) {
                    return v.value;
                  }).includes(item);
                });
              } else {
                v.ovalue = v.ovalue.split(',');
              }
            } else {
              if ([7, 16].indexOf(v.type) !== -1) {
                v.ovalue = Number(v.ovalue);
              }
            }
          }

          if (!v.tfvvalue) {
            // 空数据格式化
            if ([10, 15].indexOf(v.type) !== -1) {
              v.tfvvalue = '';
              v.ovalue = [];
            } else {
              v.tfvvalue = '';
            }
          } else {
            // 数据回显
            if ([10, 15].indexOf(v.type) !== -1) {
              v.ovalue = v.tfvvalue.split(',');
            } else if (v.type === 4) {
              v.tfvvalue = new Date(utils.date.formatDate(v.tfvvalue)).Format('YYYY-MM-DD');
            } else if (v.type === 5) {// v.tfvvalue = new Date(utils.date.formatDate(v.tfvvalue)).Format('HH:mm')
            } else if (v.type === 6) {
              v.tfvvalue = new Date(utils.date.formatDate(v.tfvvalue)).Format('YYYY-MM-DD HH:mm');
            } else if (v.type === 11) {
              var pos = v.tfvvalue.split(',');

              if (pos[3] && pos[4]) {
                v.ovalue = [pos[3], pos[4]];
              } else {
                v.ovalue = [];
              }
            }
          }
        });
        this.list = list;
      },
      deep: true
    },
    list: {
      handler: function handler(data) {
        var _this2 = this;

        // 数据格式化
        var actions = new Map([[/^(8|9|10|15|18)$/, function (val) {
          return Array.isArray(val.ovalue) ? val.ovalue.join(',') : '';
        }], [/^(3|7|16)$/, function (val) {
          return val.ovalue;
        }], [/^[456]$/, function (val) {
          return val.tfvvalue ? val.tfvvalue : '';
        }], [/^default$/, function (val) {
          return val.tfvvalue ? val.tfvvalue : '';
        }]]);

        function flatArr() {
          var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
          return arr.reduce(function (p, c) {
            p = p.concat(c).concat(flatArr(c.dropList));
            return p;
          }, []);
        } // 获取选项等中文信息


        var valueNameActions = new Map([[/^3$/, function (val) {
          var data = val.dropList.find(function (item) {
            return Number(item.value) === Number(val.ovalue);
          });
          return data ? data.name : '';
        }], [/^[456]$/, function (val) {
          return val.tfvvalue ? val.tfvvalue : '';
        }], [/^8$/, function (val) {
          return val.dropList.filter(function (item) {
            return val.ovalue.indexOf(item.value) !== -1;
          }).map(function (item) {
            return item.name;
          }).join(',') || '';
        }], [/^9$/, function (val) {
          return val.tfvvalue ? val.tfvvalue : '';
        }], [/^(7|16)$/, function (val) {
          return val.ovalue === 1 ? '是' : '否';
        }], [/^(10|15)$/, function (val) {
          return Array.isArray(val.ovalue) ? val.ovalue.join(',') : '';
        }], [/^11$/, function (val) {
          return val.tfvvalue.split(',')[0] ? val.tfvvalue.split(',')[0] : '';
        }], [/^(18)$/, function (val) {
          return val._name || flatArr(val.dropList).filter(function (item) {
            return val.ovalue.includes(item.id);
          }).map(function (item) {
            return item.value;
          }).join(',') || '';
        }], [/^default$/, function (val) {
          return val.tfvvalue ? val.tfvvalue : '';
        }]]); // change事件，数据格式化并 emit

        var arr = data.map(function (val) {
          var obj = {
            id: val.id,
            type: val.type
          };

          if (val.nodeId) {
            obj.nodeId = val.nodeId;
          }

          if (val.tfvid) {
            obj.tfvid = val.tfvid;
          }

          obj.value = _toConsumableArray(actions).find(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 1),
                key = _ref2[0];

            return key.test("".concat(val.type)) || key.test('default');
          })[1](val);

          if (_this2.getValueName) {
            obj.name = _toConsumableArray(valueNameActions).find(function (_ref3) {
              var _ref4 = _slicedToArray(_ref3, 1),
                  key = _ref4[0];

              return key.test("".concat(val.type)) || key.test('default');
            })[1](val);
          }

          return obj;
        });
        this.$emit('on-change', arr);
        this.$emit('on-change-origin', data);
      },
      deep: true
    }
  },
  methods: {
    arrCopyValue: function arrCopyValue(item) {
      return {
        get: function get() {
          return item.value ? item.value.split(',') : [];
        },
        set: function set(v) {
          item.$emit('input', v.join(','));
        }
      };
    },
    spliteHyperLink: function spliteHyperLink() {
      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      url = url || '';
      var index = url.indexOf(',') > 0 ? url.indexOf(',') : 0;
      return [url.slice(0, index), url.slice(index + 1)];
    },
    // 数据重置

    /* eslint-disable no-return-assign */
    resetFormFields: function resetFormFields() {
      var actions = new Map([[/^(3|8|18)$/, function (val) {
        return val.ovalue = [];
      }], [/^(7|16)$/, function (val) {
        return val.ovalue = 0;
      }], [/^[456]$/, function (val) {
        return val.tfvvalue = '';
      }], [/^(9|10|11|15)$/, function (val) {
        val.tfvvalue = '';
        val.ovalue = [];
      }], [/^default$/, function (val) {
        return val.tfvvalue = '';
      }]]);
      this.list.forEach(function (item) {
        ;

        _toConsumableArray(actions).find(function (_ref5) {
          var _ref6 = _slicedToArray(_ref5, 1),
              key = _ref6[0];

          return key.test("".concat(item.type)) || key.test('default');
        })[1](item);
      });
    },
    xAddressOnChange: function xAddressOnChange(item, val, val2) {
      item.tfvvalue = val2.join(',');
    },
    numberValidate: function numberValidate(value) {
      if (!/^[0-9]+.?[0-9]*$/.test(value)) {
        return {
          valid: false,
          msg: '请输入正确的数字类型'
        };
      }

      return {
        valid: true
      };
    },
    // 表单验证（自定义操作事件）
    formValidateFuc: function formValidateFuc() {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        var _iterator = _createForOfIteratorHelper(_this3.list),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var val = _step.value;

            if (val.type === 2) {
              if (val.tfvvalue !== '' && !/^[0-9]+.?[0-9]*$/.test(val.tfvvalue)) {
                reject(val);
              }
            }

            if (val.is_view && val.is_view === 1 && val.is_required && val.is_required === 1) {
              if ([3, 7, 8, 9, 10, 15, 18].indexOf(val.type) !== -1) {
                if (val.ovalue.length === 0) {
                  reject(val);
                }
              } else {
                if (!val.tfvvalue) {
                  reject(val);
                }
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        resolve(true);
      });
    },
    // 表单验证（已定义必填提示操作事件）
    formValidate: function formValidate() {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        _this4.formValidateFuc().then(function (res) {
          resolve(true);
        }).catch(function (e) {
          _this4.$vux.toast.text("\u8BF7\u586B\u5199".concat(e.name || e.tfname || ''));

          resolve(false);
        });
      });
    }
  },
  created: function created() {}
};